<template>
    <div id="notifications" />
</template>

<script>
// import Utils from '../../js/utils';
import * as R from 'ramda';

export default {
    store: [
        'api',
        'user',
    ],
    data () {
        return {

        };
    },
    mounted: function () {
    },
    created: function () {
        this.$events.on('notifications-push', (data) => {
            if (!data) {
                data = {
                    type: 'default',
                    cb: () => { }
                }
            }
            console.log('notifications-push-event', data.type);
            this.notificationPermission(data.type, data.cb);
        });
        this.$events.on('notifications-sms', (prompt) => {
            if (prompt) {
                f7.dialog.confirm('In order to make sure you’re getting the most out of Coral we’d like to send you text messages occasionally. (Don’t worry, they’re SFW)', () => {
                    this.user.communication.sms = { pulse: true, activity: true, news: true };
                    this.$events.fire('user-save');
                    this.$http
                        .post(`${this.api}/users/${this.user.id}/compliancesms`)
                        .then(
                            () => {
                                console.log('compliancesms ok');
                            },
                            response => {
                                console.error('compliancesms error: ', response.body.message);
                            }
                        );
                });
            } else {
                this.complianceSMSChange();
            }
        });
    },
    methods: {
        complianceSMSChange: function () {
            const { communication: { sms: { pulse, activity, news } } } = this.user;
            const togglesSwitch = [pulse, activity, news];
            const allTurnedOff = R.all(R.equals(false));
            // const anyTurnOn = R.any(R.equals(true));

            if (!allTurnedOff(togglesSwitch)) {
                this.$http
                    .post(`${this.api}/users/${this.user.id}/compliancesms`)
                    .then(
                        () => {
                            console.log('compliancesms ok');
                        },
                        response => {
                            console.error('compliancesms error: ', response.body.message);
                        }
                    );
            }
        },
        notificationPermission: function (type, cb) {
            console.log('notificationPermission');
            if (window.localStore.getItem('notifications-push')) {
                window.app.$events.fire('push-setup');
                cb();
                return setTimeout(() => {
                    window.app.$events.fire('push-check');
                }, 10000);
            }
            window.localStore.setItem('notifications-push', true);
            this.$events.fire('trackEvent', `notifications_ask`, 'onboarding');
            if (pgap) {
                if (device.platform === 'iOS') {
                    let text = 'Enable notifications now to experience Coral fully (don’t worry, they’re SFW)';
                    if (type === 'pulse') text = 'Would you like to enable weekly pulse reminders?';
                    if (type === 'goals') text = 'Enable notifications now and we\'ll keep you on track to meet your goals. (don’t worry, they’re SFW)';
                    f7.dialog.create({
                        title: 'Coral',
                        text,
                        buttons: [
                            {
                                text: 'Maybe later',
                                onClick: () => {
                                    setTimeout(cb, 100);
                                    setTimeout(() => {
                                        window.app.$events.fire('push-check');
                                    }, 10000);
                                }
                            },
                            {
                                text: 'Yes',
                                onClick: () => {
                                    window.app.$events.fire('push-setup');
                                    setTimeout(cb, 100);
                                    setTimeout(() => {
                                        window.app.$events.fire('push-check');
                                    }, 10000);
                                }
                            }]
                    }).open();
                } else {
                    // no need for dialog on android
                    window.app.$events.fire('push-setup');
                    setTimeout(cb, 100);
                    setTimeout(() => {
                        window.app.$events.fire('push-check');
                    }, 10000);
                }
            } else {
                if (!('Notification' in window)) {
                    console.log('This browser does not support notifications!');
                } else {
                    Notification.requestPermission(status => {
                        console.log(status, 'Notification permission status:');
                        if (status) {
                            this.$events.fire('trackEvent', `notifications_enabled`, 'onboarding');
                            window.localStore.setItem('notifications', true);
                        }
                    });
                }
                setTimeout(cb, 200);
            }
        }
    }
};
</script>
<style lang="less" scoped>
#notifications {
    display: hidden;
}
</style>
